import { accessControlSwitchInitialstate, addUserInitialstate, deleteUserInitialstate, downloadSampleCsvInitialstate, exportUsersInitialstate, importUsersInitialstate, usersInitialState } from 'Actions/appAccessControlAction';
import { appAccessControlConstants } from 'Constants/appAccessControl.constants';

export const appAccessControlUsers = (state=usersInitialState(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.USERS_REQUEST:
        case appAccessControlConstants.USERS_SUCCESS:
        case appAccessControlConstants.USERS_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const appAccessControlAddUser = (state=addUserInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.ADD_USER_REQUEST:
        case appAccessControlConstants.ADD_USER_SUCCESS:
        case appAccessControlConstants.ADD_USER_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const appAccessControlSwitch = (state=accessControlSwitchInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.ACCESS_GRANT_REQUEST:
        case appAccessControlConstants.ACCESS_GRANT_SUCCESS:
        case appAccessControlConstants.ACCESS_GRANT_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const appAccessControlDeleteUser = (state=deleteUserInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.DELETE_USER_REQUEST:
        case appAccessControlConstants.DELETE_USER_SUCCESS:
        case appAccessControlConstants.DELETE_USER_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const appAccessControlImportUsers = (state=importUsersInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.IMPORT_USERS_REQUEST:
        case appAccessControlConstants.IMPORT_USERS_SUCCESS:
        case appAccessControlConstants.IMPORT_USERS_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const aacDownloadSampleCsv = (state=downloadSampleCsvInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_REQUEST:
        case appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_SUCCESS:
        case appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export const aacExportUsers = (state=exportUsersInitialstate(), action={}) => {
    switch(action.type){
        case appAccessControlConstants.EXPORT_USERS_REQUEST:
        case appAccessControlConstants.EXPORT_USERS_SUCCESS:
        case appAccessControlConstants.EXPORT_USERS_FAILURE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}